<template>
  <nav>
    <!-- Cole o HTML do header/navbar do template aqui -->
    <!--    <header id="header" class="header d-flex align-items-center sticky-top">
-->
    <header id="header" class="header d-flex align-items-center fixed-top">
      <div
        class="container-fluid container-xl position-relative d-flex align-items-center"
      >
        <a href="/" class="logo d-flex align-items-center me-auto">
          <!-- Uncomment the line below if you also wish to use an image logo -->
          <img
            src="assets/img/INCUBATOR FINAL PNG.png"
            alt=""
            class="logo-img"
          />
          <!--<h1 class="sitename"> INCULOGO</h1>-->
        </a>

        <nav id="navmenu" class="navmenu">
          <ul>
            <li><a href="/" class="active">Home</a></li>
            <li class="dropdown">
              <a href="#"
                ><span>Incubator</span>
                <i class="bi bi-chevron-down toggle-dropdown"></i
              ></a>
              <ul>
                <li><a href="/projeto">Projeto Incubator</a></li>
                <li><a href="/equipa">Equipa</a></li>
              </ul>
            </li>
            <li class="dropdown">
              <a href="#"
                ><span>Biologia da Próstata</span>
                <i class="bi bi-chevron-down toggle-dropdown"></i
              ></a>
              <ul>
                <li><a href="/saudemasculina">Saúde Prostática</a></li>
                <li class="dropdown">
                  <a href="#"
                    ><span>Doenças de Próstata</span>
                    <i class="bi bi-chevron-down toggle-dropdown"></i
                  ></a>
                  <ul>
                    <li class="dropdown">
                      <a href="/cancro"
                        >Cancro da Próstata
                        <i class="bi bi-chevron-down toggle-dropdown"></i
                      ></a>

                      <ul>
                        <li><a href="/tratamentocancro">Tratamento</a></li>
                      </ul>
                    </li>
                    <li><a href="/prostatite">Prostatite</a></li>
                    <li><a href="/hiperplazia">Hiperplasia Benigna</a></li>
                  </ul>
                </li>
              </ul>
            </li>

            <li class="dropdown">
              <a href="/analisesclinicas">
                <span>Análises Clínicas</span>
                <i class="bi bi-chevron-down toggle-dropdown"></i
              ></a>
              <ul>
                <li class="dropdown">
                  <a href="#"
                    ><span>Exames Físicos</span>
                    <i class="bi bi-chevron-down toggle-dropdown"></i
                  ></a>
                  <ul>
                    <li><a href="/exameimagens">Exames de Imagens</a></li>
                    <li>
                      <a href="/toqueretal"> Toque Retal</a>
                    </li>
                  </ul>
                </li>

                <li class="dropdown">
                  <a href="#"
                    ><span>Exames Biológicos</span>
                    <i class="bi bi-chevron-down toggle-dropdown"></i
                  ></a>
                  <ul>
                    <li><a href="/examesanguineo">PSA</a></li>
                    <li><a href="/examehistopatologico">Histopatológico</a></li>
                    <li><a href="/examelipidomica">Exame Lipídomica</a></li>
                  </ul>
                </li>
              </ul>
            </li>

            <!--  DIAGNOSTICO TERA ACESSO RESTRITO / funcionando perfeitamente-->
            <li class="dropdown">
              <a
                href="#"
                @click.prevent="toggleDropdown"
                data-restricted="true"
              >
                <span>Diagnóstico</span>
                <i class="bi bi-chevron-down toggle-dropdown"></i>
              </a>

              <ul v-show="dropdownOpen">
                <li>
                  <a href="/diagtoqueretal">Interpretação Toque Retal</a>
                </li>
                <li><a href="/resultadosPSA">Interpretação de PSA</a></li>
                <li class="dropdown">
                  <a href="/resultadoshistopatologico"
                    >Interpretação Histopatologia
                    <i class="bi bi-chevron-down toggle-dropdown"></i
                  ></a>
                  <ul>
                    <li>
                      <a href="/resultadosh&e">Resultados de Análises H&E </a>
                    </li>
                    <li>
                      <a href="/resultadosihq">Resultados de Análises IHQ </a>
                    </li>
                  </ul>
                </li>
                <!--<li>
                  <a href="#">Interpretação Lipidómica </a>
                </li>-->
                <li>
                  <a href="/guidelines">Guidelines Clínicos </a>
                </li>
              </ul>
            </li>

            <!-- LAB VIRTUAL AQUI TERA ACESSO RESTRITO-->
            <li class="dropdown">
              <a
                href="#"
                @click.prevent="toggleDropdown"
                data-restricted="true"
              >
                <span>Lab Virtual</span>
                <i class="bi bi-chevron-down toggle-dropdown"></i>
              </a>
              <ul v-show="dropdownOpen">
                 <li><a href="/lab3d">Lab 3D</a></li>
                <li><a href="/salavirtual">Sala de Aulas Virtual</a></li>
                <!--<li><a href="/salavirtual">Cursos</a></li>-->
                 <li><a href="#">Molecular</a></li>
                  <li class="dropdown">
                  <a href="#"
                    ><span>Histopatologia</span>
                    <i class="bi bi-chevron-down toggle-dropdown"></i
                  ></a>
                  <ul>
                    <li><a href="/fixacao">Fixação</a></li>
                    <li><a href="/examemacroscopica">Exame Macroscópico</a></li>
                    <li>
                      <a href="/desidratacao"
                        >Desidratação, Diafanização e Impregnação</a
                      >
                    </li>
                    <li><a href="/inclusao">Inclusão</a></li>
                    <li><a href="/cortes">Cortes</a></li>

                    <li class="dropdown">
                      <a href="#"
                        >Coloração
                        <i class="bi bi-chevron-down toggle-dropdown"></i
                      ></a>

                      <ul>
                        <li><a href="/h&e">H&E</a></li>
                        <li>
                          <a href="/ihq"> IHQ</a>
                        </li>
                      </ul>
                    </li>
                    <li><a href="/montagem">Montagem</a></li>
                    <li><a href="/microscopica">Análise Microscópica</a></li>
                  </ul>
                </li>
              </ul>
            </li>

            <!-- NOTICIAS-->
            <li class="dropdown">
              <a href="#"
                ><span>Publicações</span>
                <i class="bi bi-chevron-down toggle-dropdown"></i
              ></a>
              <ul>
                <li><a href="/noticias"> Notícias</a></li>
                <li><a href="/eventos">Eventos</a></li>
                <li><a href="/forum">Fórum</a></li>
                <li><a href="/repositorio">Repositórios</a></li>
                <li><a href="/videos">Videos</a></li>
                <li><a href="/galerias">Galerias</a></li>
              </ul>
            </li>
          </ul>
          <i class="mobile-nav-toggle d-xl-none bi bi-list"></i>
        </nav>

        <!-- Modal Bootstrap -->
        <div
          v-if="showModal"
          class="modal fade show"
          tabindex="-1"
          style="display: block"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Welcome to INCUBATOR</h5>
                <button
                  type="button"
                  class="btn-close"
                  @click="closeModal"
                ></button>
              </div>
              <div class="modal-body">
                <!-- Alertas -->
                <div
                  v-if="successMessage"
                  class="alert alert-success text-center"
                >
                  {{ successMessage }}
                </div>
                <div v-if="errorMessage" class="alert alert-danger text-center">
                  {{ errorMessage }}
                </div>

                <!-- Formulário de login -->
                <form @submit.prevent="login">
                  <div class="form-group mb-3">
                    <label for="exampleInputEmail1">Email address</label>
                    <div class="input-group">
                      <span class="input-group-text">
                        <i class="bi bi-person"></i>
                      </span>
                      <input
                        v-model="loginForm.email"
                        type="email"
                        class="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        required
                      />
                    </div>
                  </div>

                  <div class="form-group mb-3">
                    <label for="exampleInputPassword1">Password</label>
                    <div class="input-group">
                      <span class="input-group-text">
                        <i class="bi bi-lock"></i>
                      </span>
                      <input
                        v-model="loginForm.password"
                        type="password"
                        class="form-control"
                        id="exampleInputPassword1"
                        required
                      />
                    </div>
                  </div>

                  <button
                    type="submit"
                    id="btn-getstarted"
                    class="btn btn-gradient w-100"
                  >
                    <i class="bi bi-box-arrow-in-right me-2"></i> Sign In
                  </button>
                  <br />
                  <div class="text-center mt-3">
                    Não possui uma conta?
                    <a href="#" @click.prevent="openRegisterModal">
                      Solicite aqui o seu acesso!
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- MODAL DE REGISTRO -->
        <div
          v-if="showRegisterModal"
          class="modal fade show"
          tabindex="-1"
          style="display: block"
        >
          <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" style="text-align: center">
                  <b style="color: black"
                    >Pedido de Acesso à Plataforma INCUBATOR</b
                  >
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  @click="closeRegisterModal"
                ></button>
              </div>
              <div class="modal-body">
                <div
                  v-if="registerSuccessMessage"
                  class="alert alert-success text-center"
                >
                  {{ registerSuccessMessage }}
                </div>
                <div
                  v-if="registerErrorMessage"
                  class="alert alert-danger text-center"
                >
                  {{ registerErrorMessage }}
                </div>

                <form @submit.prevent="submitRegister">
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <label>Nome <span class="text-danger">*</span></label>
                      <input
                        v-model="registerForm.name"
                        type="text"
                        class="form-control"
                        required
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label>Email <span class="text-danger">*</span></label>
                      <input
                        v-model="registerForm.email"
                        type="email"
                        class="form-control"
                        required
                      />
                    </div>

                    <div class="col-md-6 mb-3">
                      <label>Password <span class="text-danger">*</span></label>
                      <input
                        v-model="registerForm.password"
                        type="password"
                        class="form-control"
                        required
                        placeholder="Mínimo 8 caracteres ..."
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label>Idade <span class="text-danger">*</span></label>
                      <input
                        v-model="registerForm.idade"
                        type="number"
                        class="form-control"
                        required
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="genero"
                        >Género <span class="text-danger">*</span></label
                      >
                      <div class="input-group">
                        <select
                          v-model="registerForm.genero"
                          id="genero"
                          class="form-select"
                          required
                        >
                          <option disabled value="">-- Selecione --</option>
                          <option value="masculino">Masculino</option>
                          <option value="feminino">Feminino</option>
                          <option value="Nao Revelar">
                            Prefiro não revelar
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-6 mb-3">
                      <label
                        >Profissão <span class="text-danger">*</span></label
                      >
                      <input
                        v-model="registerForm.profissao"
                        type="text"
                        class="form-control"
                        required
                        placeholder="Ex: Estudante"
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="pais"
                        >Nacionalidade <span class="text-danger">*</span></label
                      >
                      <select
                        v-model="registerForm.pais"
                        id="pais"
                        class="form-select"
                        required
                      >
                        <option disabled value="">
                          -- Selecione seu país --
                        </option>
                        <option value="Afeganistão">Afeganistão</option>
                        <option value="África do Sul">África do Sul</option>
                        <option value="Albânia">Albânia</option>
                        <option value="Alemanha">Alemanha</option>
                        <option value="Andorra">Andorra</option>
                        <option value="Angola">Angola</option>
                        <option value="Antígua e Barbuda">
                          Antígua e Barbuda
                        </option>
                        <option value="Arábia Saudita">Arábia Saudita</option>
                        <option value="Argélia">Argélia</option>
                        <option value="Argentina">Argentina</option>
                        <option value="Armênia">Armênia</option>
                        <option value="Austrália">Austrália</option>
                        <option value="Áustria">Áustria</option>
                        <option value="Azerbaijão">Azerbaijão</option>
                        <option value="Bahamas">Bahamas</option>
                        <option value="Bangladesh">Bangladesh</option>
                        <option value="Barbados">Barbados</option>
                        <option value="Barein">Barein</option>
                        <option value="Bélgica">Bélgica</option>
                        <option value="Belize">Belize</option>
                        <option value="Benim">Benim</option>
                        <option value="Butão">Butão</option>
                        <option value="Bolívia">Bolívia</option>
                        <option value="Bósnia e Herzegovina">
                          Bósnia e Herzegovina
                        </option>
                        <option value="Botsuana">Botsuana</option>
                        <option value="Brasil">Brasil</option>
                        <option value="Brunei">Brunei</option>
                        <option value="Bulgária">Bulgária</option>
                        <option value="Burquina Faso">Burquina Faso</option>
                        <option value="Burundi">Burundi</option>
                        <option value="Cabo Verde">Cabo Verde</option>
                        <option value="Camarões">Camarões</option>
                        <option value="Camboja">Camboja</option>
                        <option value="Canadá">Canadá</option>
                        <option value="Catar">Catar</option>
                        <option value="Chade">Chade</option>
                        <option value="Chile">Chile</option>
                        <option value="China">China</option>
                        <option value="Chipre">Chipre</option>
                        <option value="Colômbia">Colômbia</option>
                        <option value="Comores">Comores</option>
                        <option value="Congo">Congo</option>
                        <option value="Coreia do Norte">Coreia do Norte</option>
                        <option value="Coreia do Sul">Coreia do Sul</option>
                        <option value="Costa do Marfim">Costa do Marfim</option>
                        <option value="Costa Rica">Costa Rica</option>
                        <option value="Croácia">Croácia</option>
                        <option value="Cuba">Cuba</option>
                        <option value="Dinamarca">Dinamarca</option>
                        <option value="Djibuti">Djibuti</option>
                        <option value="Dominica">Dominica</option>
                        <option value="Egito">Egito</option>
                        <option value="El Salvador">El Salvador</option>
                        <option value="Emirados Árabes Unidos">
                          Emirados Árabes Unidos
                        </option>
                        <option value="Equador">Equador</option>
                        <option value="Eritreia">Eritreia</option>
                        <option value="Eslováquia">Eslováquia</option>
                        <option value="Eslovênia">Eslovênia</option>
                        <option value="Espanha">Espanha</option>
                        <option value="Estados Unidos">Estados Unidos</option>
                        <option value="Estônia">Estônia</option>
                        <option value="Eswatini">Eswatini</option>
                        <option value="Etiópia">Etiópia</option>
                        <option value="Fiji">Fiji</option>
                        <option value="Filipinas">Filipinas</option>
                        <option value="Finlândia">Finlândia</option>
                        <option value="França">França</option>
                        <option value="Gabão">Gabão</option>
                        <option value="Gâmbia">Gâmbia</option>
                        <option value="Gana">Gana</option>
                        <option value="Geórgia">Geórgia</option>
                        <option value="Granada">Granada</option>
                        <option value="Grécia">Grécia</option>
                        <option value="Guatemala">Guatemala</option>
                        <option value="Guiana">Guiana</option>
                        <option value="Guiné">Guiné</option>
                        <option value="Guiné-Bissau">Guiné-Bissau</option>
                        <option value="Guiné Equatorial">
                          Guiné Equatorial
                        </option>
                        <option value="Haiti">Haiti</option>
                        <option value="Holanda">Holanda</option>
                        <option value="Honduras">Honduras</option>
                        <option value="Hungria">Hungria</option>
                        <option value="Iémen">Iémen</option>
                        <option value="Ilhas Marshall">Ilhas Marshall</option>
                        <option value="Ilhas Salomão">Ilhas Salomão</option>
                        <option value="Índia">Índia</option>
                        <option value="Indonésia">Indonésia</option>
                        <option value="Irã">Irã</option>
                        <option value="Iraque">Iraque</option>
                        <option value="Irlanda">Irlanda</option>
                        <option value="Islândia">Islândia</option>
                        <option value="Israel">Israel</option>
                        <option value="Itália">Itália</option>
                        <option value="Jamaica">Jamaica</option>
                        <option value="Japão">Japão</option>
                        <option value="Jordânia">Jordânia</option>
                        <option value="Kosovo">Kosovo</option>
                        <option value="Kuwait">Kuwait</option>
                        <option value="Laos">Laos</option>
                        <option value="Lesoto">Lesoto</option>
                        <option value="Letônia">Letônia</option>
                        <option value="Líbano">Líbano</option>
                        <option value="Libéria">Libéria</option>
                        <option value="Líbia">Líbia</option>
                        <option value="Liechtenstein">Liechtenstein</option>
                        <option value="Lituânia">Lituânia</option>
                        <option value="Luxemburgo">Luxemburgo</option>
                        <option value="Macedônia do Norte">
                          Macedônia do Norte
                        </option>
                        <option value="Madagáscar">Madagáscar</option>
                        <option value="Malásia">Malásia</option>
                        <option value="Malaui">Malaui</option>
                        <option value="Maldivas">Maldivas</option>
                        <option value="Mali">Mali</option>
                        <option value="Malta">Malta</option>
                        <option value="Marrocos">Marrocos</option>
                        <option value="Maurícia">Maurícia</option>
                        <option value="Mauritânia">Mauritânia</option>
                        <option value="México">México</option>
                        <option value="Micronésia">Micronésia</option>
                        <option value="Moçambique">Moçambique</option>
                        <option value="Moldávia">Moldávia</option>
                        <option value="Mônaco">Mônaco</option>
                        <option value="Mongólia">Mongólia</option>
                        <option value="Montenegro">Montenegro</option>
                        <option value="Myanmar">Myanmar</option>
                        <option value="Namíbia">Namíbia</option>
                        <option value="Nauru">Nauru</option>
                        <option value="Nepal">Nepal</option>
                        <option value="Nicarágua">Nicarágua</option>
                        <option value="Níger">Níger</option>
                        <option value="Nigéria">Nigéria</option>
                        <option value="Noruega">Noruega</option>
                        <option value="Nova Zelândia">Nova Zelândia</option>
                        <option value="Omã">Omã</option>
                        <option value="Palau">Palau</option>
                        <option value="Panamá">Panamá</option>
                        <option value="Papua-Nova Guiné">
                          Papua-Nova Guiné
                        </option>
                        <option value="Paquistão">Paquistão</option>
                        <option value="Paraguai">Paraguai</option>
                        <option value="Peru">Peru</option>
                        <option value="Polônia">Polônia</option>
                        <option value="Portugal">Portugal</option>
                        <option value="Quênia">Quênia</option>
                        <option value="Quirguistão">Quirguistão</option>
                        <option value="Reino Unido">Reino Unido</option>
                        <option value="República Centro-Africana">
                          República Centro-Africana
                        </option>
                        <option value="República Democrática do Congo">
                          República Democrática do Congo
                        </option>
                        <option value="República Dominicana">
                          República Dominicana
                        </option>
                        <option value="República Tcheca">
                          República Tcheca
                        </option>
                        <option value="Romênia">Romênia</option>
                        <option value="Ruanda">Ruanda</option>
                        <option value="Rússia">Rússia</option>
                        <option value="San Marino">San Marino</option>
                        <option value="Santa Lúcia">Santa Lúcia</option>
                        <option value="São Cristóvão e Nevis">
                          São Cristóvão e Nevis
                        </option>
                        <option value="São Tomé e Príncipe">
                          São Tomé e Príncipe
                        </option>
                        <option value="São Vicente e Granadinas">
                          São Vicente e Granadinas
                        </option>
                        <option value="Seicheles">Seicheles</option>
                        <option value="Senegal">Senegal</option>
                        <option value="Serra Leoa">Serra Leoa</option>
                        <option value="Sérvia">Sérvia</option>
                        <option value="Singapura">Singapura</option>
                        <option value="Síria">Síria</option>
                        <option value="Somália">Somália</option>
                        <option value="Sri Lanka">Sri Lanka</option>
                        <option value="Sudão">Sudão</option>
                        <option value="Sudão do Sul">Sudão do Sul</option>
                        <option value="Suécia">Suécia</option>
                        <option value="Suíça">Suíça</option>
                        <option value="Suriname">Suriname</option>
                        <option value="Tailândia">Tailândia</option>
                        <option value="Tanzânia">Tanzânia</option>
                        <option value="Tchéquia">Tchéquia</option>
                        <option value="Togo">Togo</option>
                        <option value="Tonga">Tonga</option>
                        <option value="Trinidad e Tobago">
                          Trinidad e Tobago
                        </option>
                        <option value="Tunísia">Tunísia</option>
                        <option value="Turcomenistão">Turcomenistão</option>
                        <option value="Turquia">Turquia</option>
                        <option value="Tuvalu">Tuvalu</option>
                        <option value="Ucrânia">Ucrânia</option>
                        <option value="Uganda">Uganda</option>
                        <option value="Uruguai">Uruguai</option>
                        <option value="Uzbequistão">Uzbequistão</option>
                        <option value="Vanuatu">Vanuatu</option>
                        <option value="Vaticano">Vaticano</option>
                        <option value="Venezuela">Venezuela</option>
                        <option value="Vietnã">Vietnã</option>
                        <option value="Zâmbia">Zâmbia</option>
                        <option value="Zimbábue">Zimbábue</option>
                      </select>
                    </div>

                    <div class="col-md-12 mb-3">
                      <label
                        >Comprovativo de inscrição
                        <span class="text-danger">*</span></label
                      >
                      <div class="input-group">
                        <span class="input-group-text">
                          <i class="bi bi-paperclip"></i>
                        </span>
                        <input
                          type="file"
                          class="form-control"
                          @change="handleFileUpload($event, 1)"
                          required
                        />
                      </div>
                      <b id="idnota">
                        ⚠️ Anexe a declaração de matrícula (para estudantes) ou
                        o diploma (para investigadores).
                      </b>
                    </div>

                    <div class="col-md-12 mb-3">
                      <label
                        >Comprovativo de Pagamento
                        <span class="text-danger">*</span></label
                      >
                      <div class="input-group">
                        <span class="input-group-text">
                          <i class="bi bi-paperclip"></i>
                        </span>
                        <input
                          type="file"
                          class="form-control"
                          @change="handleFileUpload($event, 2)"
                          required
                        />
                      </div>
                    </div>

                    <br />

                    <br />
                  </div>

                  <button
                    type="submit"
                    id="btn-getstarted"
                    class="btn btn-gradient w-100"
                  >
                    <i class="bi bi-send"></i> Enviar Requisição
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal backdrop -->
        <div
          v-if="showModal || showRegisterModal"
          class="modal-backdrop fade show"
        ></div>

        <!-- Modal backdrop -->
        <div v-if="showModal" class="modal-backdrop fade show"></div>
      </div>
    </header>
  </nav>
</template>

<script>
import axios from "axios";
import { API_ENDPOINT } from "../main.js";
import { isSessionValid, FIFTEEN_MINUTES } from "../config.js";

export default {
  name: "AppNavbar",

  data() {
    return {
      user: null,
      showModal: false,
      dropdownOpen: false,
      loginForm: { email: "", password: "", remember: false },
      errorMessage: "",
      successMessage: "",
      showRegisterModal: false,
      registerForm: {
        name: "",
        email: "",
        password: "",
        idade: "",
        genero: "",
        pais: "",
        profissao: "",
        attachment1: null,
        attachment2: null,
      },
      registerSuccessMessage: "",
      registerErrorMessage: "",
    };
  },

  methods: {
    handleFileUpload(event, index) {
      const file = event.target.files[0];
      if (index === 1) this.registerForm.attachment1 = file;
      if (index === 2) this.registerForm.attachment2 = file;
    },
    openRegisterModal() {
      this.showModal = false; // fecha o modal de login
      this.showRegisterModal = true; // abre o modal de registro
    },
    closeRegisterModal() {
      this.showRegisterModal = false;
      this.registerForm.name = "";
      this.registerForm.email = "";
      this.registerForm.password = "";
      this.registerForm.idade = "";
      this.registerForm.genero = "";
      this.registerForm.profissao = "";
      this.registerForm.pais = "";
      this.registerSuccessMessage = "";
      this.registerErrorMessage = "";
    },
    async submitRegister() {
      try {
        if (!this.registerForm.attachment1 || !this.registerForm.attachment2) {
          this.registerErrorMessage =
            "Por favor, envie os 2 anexos obrigatórios.";
          return;
        }

        const formData = new FormData();
        formData.append("name", this.registerForm.name);
        formData.append("email", this.registerForm.email);
        formData.append("password", this.registerForm.password);
        formData.append("idade", this.registerForm.idade);
        formData.append("genero", this.registerForm.genero);
        formData.append("profissao", this.registerForm.profissao);
        formData.append("pais", this.registerForm.pais);
        formData.append("attachment1", this.registerForm.attachment1);
        formData.append("attachment2", this.registerForm.attachment2);

        const res = await axios.post(
          `${API_ENDPOINT}/api/medical-request`,
          formData
        );

        if (res.data.success) {
          this.registerSuccessMessage =
            "Registro enviado com sucesso! Aguarde a administração.";
          this.registerErrorMessage = "";

          // limpa o formulário
          this.registerForm = {
            name: "",
            email: "",
            password: "",
            profissao: "",
            idade: "",
            genero: "",
            pais: "",
            attachment1: null,
            attachment2: null,
          };

          setTimeout(() => {
            this.showRegisterModal = false;
            this.registerSuccessMessage = "";
          }, 5000);
        } else {
          this.registerErrorMessage =
            res.data.message || "Erro ao enviar registro.";
          this.registerSuccessMessage = "";
        }
      } catch (err) {
        this.registerErrorMessage = "Erro ao enviar registro.";
        this.registerSuccessMessage = "";
        console.error(err);
      }
    },
    // --- MÉTODOS ATUALIZADOS PARA O MENU MOBILE ---
    toggleMobileNav(event) {
      event.preventDefault();
      const navmenu = document.querySelector("#navmenu");
      if (navmenu) {
        /* antes estava assim funcionando
        navmenu.classList.toggle("mobile-nav-active");
        const toggleIcon = event.currentTarget;
        toggleIcon.classList.toggle("bi-list");
        toggleIcon.classList.toggle("bi-x");*/
        navmenu.classList.toggle("mobile-nav-active");
        event.currentTarget.classList.toggle("bi-list");
        event.currentTarget.classList.toggle("bi-x");
      }
    },
    handleMobileDropdown(event) {
      if (!document.querySelector("#navmenu.mobile-nav-active")) return;

      event.preventDefault();
      const dropdown = event.target.closest(".dropdown");
      if (!dropdown) return;

      const mainLink = dropdown.querySelector("a");
      const isRestricted =
        mainLink && mainLink.getAttribute("data-restricted") === "true";

      // **A LÓGICA CORRIGIDA ESTÁ AQUI**
      // Se o menu for restrito E o usuário NÃO estiver logado, mostre o modal.
      if (isRestricted && !isSessionValid()) {
        this.showModal = true;
        return; // Para a execução aqui.
      }

      // Se o menu for restrito e o usuário JÁ ESTIVER LOGADO,
      // ou se for um dropdown normal, execute a lógica de abrir/fechar.
      // Esta parte agora funciona para TODOS os dropdowns no mobile.
      const parentUl = dropdown.closest("ul");
      if (parentUl) {
        parentUl.querySelectorAll(".dropdown.active").forEach((d) => {
          if (d !== dropdown) {
            d.classList.remove("active");
            d.querySelector("ul")?.classList.remove("dropdown-active");
          }
        });
      }

      dropdown.classList.toggle("active");
      const submenu = dropdown.querySelector("ul");
      if (submenu) {
        submenu.classList.toggle("dropdown-active");
      }
    },
    
    toggleDropdown() {
      if (isSessionValid()) {
        // Sessão válida, pode abrir dropdown
        const storedUser = JSON.parse(localStorage.getItem("user"));
        this.user = storedUser;
        this.dropdownOpen = !this.dropdownOpen;
      } else {
        // Sessão inválida, abre modal de login
        this.showModal = true;
      }
    },
    checkAccess() {
      if (!this.isLoggedIn()) {
        this.showModal = true;
      }
    },
    isLoggedIn() {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const loginTime = localStorage.getItem("loginTime");
      return (
        storedUser && loginTime && Date.now() - loginTime < FIFTEEN_MINUTES
      );
    },

    handleAccess() {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const loginTime = localStorage.getItem("loginTime");

      if (storedUser && loginTime && Date.now() - loginTime < FIFTEEN_MINUTES) {
        this.user = storedUser;
      } else {
        this.showModal = true;
      }
    },

    closeModal() {
      this.showModal = false;
      this.errorMessage = "";
      this.successMessage = "";
    },

    async login() {
      try {
        const { data } = await axios.post(
          `${API_ENDPOINT}/api/login`,
          this.loginForm,
          { withCredentials: true }
        );

        if (data.user) {
          this.user = data.user;
          localStorage.setItem("user", JSON.stringify(data.user));
          localStorage.setItem("loginTime", Date.now());

          this.successMessage = "Login realizado com sucesso!";
          this.errorMessage = "";
          this.dropdownOpen = true;

          setTimeout(() => {
            this.showModal = false;
            this.successMessage = "";
          }, 2000);
        } else {
          this.errorMessage = data.message || "Credenciais inválidas";
          this.successMessage = "";
        }
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          this.errorMessage = err.response.data.message;
        } else {
          this.errorMessage = "Erro ao tentar logar. Tente novamente.";
        }
        this.successMessage = "";
      }
    },

    async logout() {
      try {
        await axios.post(
          `${API_ENDPOINT}/api/logout`,
          {},
          { withCredentials: true }
        );
        this.user = null;
        this.dropdownOpen = false;
        localStorage.removeItem("user");
        localStorage.removeItem("loginTime");
      } catch (err) {
        console.error("Erro ao fazer logout:", err);
      }
    },
  },
  async mounted() {
    // --- INICIALIZAÇÃO DOS EVENTOS DO MENU ---
    this.$nextTick(() => {
      const mobileNavToggle = document.querySelector(".mobile-nav-toggle");
      if (mobileNavToggle) {
        mobileNavToggle.addEventListener("click", this.toggleMobileNav);
      }

      const navMenu = document.querySelector("#navmenu");
      if (navMenu) {
        navMenu.addEventListener("click", (event) => {
          // Verifica se o clique foi no ícone de dropdown
          if (event.target.matches(".toggle-dropdown")) {
            this.handleMobileDropdown(event);
          }
        });
      }
    });
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const loginTime = localStorage.getItem("loginTime");

    if (storedUser && loginTime && Date.now() - loginTime < FIFTEEN_MINUTES) {
      this.user = storedUser;
    } else {
      try {
        const { data } = await axios.get(`${API_ENDPOINT}/api/user`, {
          withCredentials: true,
        });
        if (data.user) {
          this.user = data.user;
          localStorage.setItem("user", JSON.stringify(data.user));
          localStorage.setItem("loginTime", Date.now());
        }
      } catch (err) {
        console.warn("Utilizador não logado:", err);
      }
    }
  },

  beforeUnmount() {
    // Limpeza dos eventos
    const mobileNavToggle = document.querySelector(".mobile-nav-toggle");
    if (mobileNavToggle) {
      mobileNavToggle.removeEventListener("click", this.toggleMobileNav);
    }
    // A delegação de evento não precisa de limpeza individual aqui,
    // pois o listener está no #navmenu que será destruído com o componente.
  },
};
</script>

<style scoped>
#idnota {
  color: #10b2bb;
  font-family: "Times New Roman", Times, serif;
  font-size: 15px;
}
/* Adicione aqui o CSS específico do Navbar, ou importe global no main.js */
/* 
#header {
  background: linear-gradient(to bottom, red 0%, green 100%);
  border-bottom: none;  
} */
label {
  font-weight: bold;
}
#header {
  background: linear-gradient(
    to bottom,
    #c8c8c8 0%,
    #dcdcdc 40%,
    #f0f0f0 80%,
    #f8f8f8 100%
  );
  border-bottom: none;
  min-height: 100px; /* aumenta altura para destacar o degradê */
}
#header {
  z-index: 1030; /* igual ao do Bootstrap navbar */
  width: 100%;
}
.btn-gradient {
  background: linear-gradient(to right, orange, #05b4c6);
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 0.5rem; /* arredondamento */
  padding: 0.75rem 1.5rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.btn-gradient:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  opacity: 0.95;
}

.btn-gradient:active {
  transform: translateY(0);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
}

/* Adicione este CSS dentro da sua tag <style scoped> */

/*--------------------------------------------------------------
# Mobile Navigation
--------------------------------------------------------------*/
.mobile-nav-toggle {
  color: #364d59;
  font-size: 28px;
  cursor: pointer;
  display: none;
  line-height: 0;
  transition: 0.5s;
}

@media (max-width: 1200px) {
  .mobile-nav-toggle {
    display: block;
  }

  .navmenu ul {
    display: none;
  }
}

.navmenu.mobile-nav-active {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  overflow-y: auto;
  background: rgba(33, 37, 41, 0.9); /* Fundo semi-transparente */
  transition: 0.3s;
}

.navmenu.mobile-nav-active > ul {
  display: block; /* ESSA É A REGRA CHAVE QUE MOSTRA O MENU */
  position: absolute;
  top: 55px;
  right: 15px;
  bottom: 15px;
  left: 15px;
  padding: 10px 0;
  border-radius: 8px;
  background-color: #fff;
  overflow-y: auto;
  transition: 0.3s;
  z-index: 9998;
}

.navmenu.mobile-nav-active .dropdown > a,
.navmenu.mobile-nav-active .dropdown > a:focus {
  padding: 10px 20px;
  font-size: 15px;
  color: #364d59;
}

.navmenu.mobile-nav-active .dropdown > a:hover,
.navmenu.mobile-nav-active .dropdown.active > a {
  color: #008374; /* Cor do item ativo */
}

/* Regra para mostrar os submenus quando o dropdown está ativo */
.navmenu.mobile-nav-active .dropdown .dropdown-active {
  display: block !important;
}
</style>
